<div class="search-common-commands">
    <div class="search-exports" *ngIf="useExport">
        <a rel="tooltip"
           class="export-to-csv"
           [title]="'Common.SearchActionsAndDetailsActions.ExportToCsv' | translate" alt="CSV">            
        </a>
        <a rel="tooltip"
           *ngIf="showPrint"
           class="export-to-pdf"
           (click)="print.emit(true)"
           [title]="'Common.SearchActionsAndDetailsActions.Print' | translate" alt="Print">            
        </a>
    </div>

    <div class="after-export-area">
        <ng-content select="[after-export-area]"></ng-content>
    </div>

    <waf-text-input *ngIf="useGlobalSearch"
                    class="global-search-input"
                    [(ngModel)]="searchTerm"
                    (ngModelChange)="searchTermChange.emit($event)"
                    [placeholder]="globalSearchPlaceholder | translate">
    </waf-text-input>

    <button *ngIf="useAdvancedSearch"
            class="btn btn-link advanced-search-link"
            (click)="showAdvanced = !showAdvanced;showAdvancedChange.emit(showAdvanced); false">
        <img src="/assets/images/icons/ico-advanced-search.svg" alt="Advanced Search" />
        <span>{{ 'Common.SearchActionsAndDetailsActions.AdvancedSearch' | translate }}</span>
    </button>
</div>